import React from 'react'
import PropTypes from 'prop-types'

import List from 'material-ui/List'
import ChatTextInput from './ChatTextInput'
import ChatMessageListItem from './ChatMessageListItem'
import MessagesUtils from '../infra/MessagesUtils'
import TimeUtils from '../infra/TimeUtils'
import PhotoScreen from '../common/PhotoScreen'
import ChatRoomSettings from './ChatRoomSettings'

import { connect } from 'react-redux'

class ChatRoomCurrent extends React.Component {

  static propTypes = {
    userId: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired,
    messages: PropTypes.array,
    roomId: PropTypes.string,
    userMetadata: PropTypes.object,
    teamMembers: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      userId: this.props.userId,
      userInfo: {},
      teamInfo: {}
    }
  }

  componentWillReceiveProps(props) {
    if (!this.isLoading(props)){
      if (this.props.messages !== props.messages){
        this.setState({scrollToBottom: true})
      }
      else if (this.props.roomId !== props.roomId){
        this.setState({scrollToBottom: true})
      }
    }
  }

  componentWillUnmount() {
    this.updateLastActTimestamp()
  }

  isLoading(props) {
    return !props.members
        || !props.messages
        || !props.roomMetadata
        || !props.userMetadata
        || !props.teamMembers
  }

  componentDidUpdate(){
    this.updateLastActTimestamp()

    if (this.state.scrollToBottom){
      this.scrollToBottom()
      this.setState({scrollToBottom: false})
    }
  }

  scrollToBottom = () => {
    this.messagesAnchor.scrollIntoView()
  }

  updateLastActTimestamp = () => {
    if (!this.props.userMetadata.loading && this.props.roomId  && this.props.teamId){
      TimeUtils.updateLastActTimestamp(this.props.userMetadata.value.id,
        this.props.roomId, this.props.teamId)
    }
  }

  sendTextMessage = (text) => {
    MessagesUtils.sendTextMessage(this.props.userMetadata.value,
      {id: this.props.roomId}, {id: this.props.teamId}, text)
  }
  onFileLoad = (event, file, result) => {
    MessagesUtils.sendImageMessage(this.props.userMetadata.value,
      {id: this.props.roomId}, {id: this.props.teamId}, file)
  }

  onFileInputChange = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      return
    }

    const file = e.target.files[0]
    if (!file.type.match('png|jpe?g|gif')){
      //TODO: raise alert to only upload picture
      return
    }
    const reader = new FileReader()
    reader.onload = (e) => this.onFileLoad(e, file, e.target.result)
    reader.readAsDataURL(file)
  }

  renderMessages(){

    const messagesRendered = []
    const messages = this.props.messages
    const members = this.props.members

    if (messages){

      let lastItem = {
        message: {},
        timeStr: '',
        dayStr: ''
      }

      Object.keys(messages)
        .map((id) => {
          const message = messages[id]
          message.id = id
          return message
        })
        .sort((a, b) => {
          return (a.timestamp - b.timestamp)
        })
        .forEach((message, idx) => {

          const clockOffset = this.props.clockOffset.value

          //TODO Create Fibo Avatar component that handles color. TeamInfo.members is not required here
          const teamMember = this.props.teamMembers.value.find((member) => member.userId === message.senderId)
          const sender = teamMember || {displayName: message.senderName}
          const newMessageItem = getMessageItem(clockOffset, message)

          if (lastItem.dayStr !== newMessageItem.dayStr) {
            // Different days => show a day header
            messagesRendered.push(
              <ChatMessageListItem
                key={`${newMessageItem.dayStr}-${idx}`}
                type={'date'}
                data={newMessageItem}/>)
          } else if (lastItem.message.senderId === newMessageItem.message.senderId
              && lastItem.timeStr === newMessageItem.timeStr) {
            // Two messages from same user at the same time
            newMessageItem.isSecondary = true
          }

          lastItem = newMessageItem
          messagesRendered.push(
            <ChatMessageListItem
              key={message.id}
              type={message.metadata.type}
              data={newMessageItem}
              messageSender={sender} // for color. change avatar so it handles soon
              scrollToBottom={this.scrollToBottom} //for images onload
            />
          )
        })
      }

    return messagesRendered
  }

  render() {
    let title = ""
    const isLoading = this.isLoading(this.props)

    if (!isLoading){
      title = this.props.roomMetadata.title
              || MessagesUtils.createTitleFromMembers(this.props.members, this.props.userMetadata.value)
    }

    return (
      <div
        style={{
          flexGrow:1,
          display: 'flex',
          flexDirection:'column',
        }}>
        <div
          style={{
            height: 48, //-2 to take pixel difference into account
            flexShrink:0,
            backgroundColor:'#F7F7F7',
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: '#D3D3D3',
          }}>
          <span
            style={{
              display:'flex',
              fontSize: 16,
              color:'#527da3',
              margin: 'auto'
            }}>
            {title}
          </span>
          {
            this.props.roomMetadata &&
            this.props.roomMetadata.type === 'group' &&
            <ChatRoomSettings roomId={this.props.roomId} title={title} />
          }
        </div>

        <div
          style={{
            overflow: 'auto',
            display: 'flex',
            marginBottom:'auto',
            flexDirection:'column',
          }}>
          {
            !isLoading
            &&
            (
              <List
                style={{
                  display: 'flex',
                  flexGrow: 1,
                  flexDirection: 'column'
                }}>
                {this.renderMessages()}
                <div style={{flexGrow:1}} ref={(node) => this.messagesAnchor = node}></div>
              </List>
            )
          }

        </div>

        <ChatTextInput
          roomId={this.props.roomId}
          loading={isLoading}
          sendTextMessage={this.sendTextMessage}
          onFileInputChange={this.onFileInputChange}/>

        {
          // A single PhotoScreen element for all images in the room
          <PhotoScreen />
        }
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const roomId = ownProps.roomId
  let messages = undefined
  let members = undefined
  let metadata = undefined

  // Get metadata for a particular roomId from props
  if (state.firebase.rooms.metadata) {
    const roomMetadata = state.firebase.rooms.metadata[roomId]
    if (roomMetadata && !roomMetadata.loading) {
      metadata = roomMetadata.value
    }
  }

  // Get members for a particular roomId from props
  if (state.firebase.rooms.members) {
    const roomMembers = state.firebase.rooms.members[roomId]
    if (roomMembers && !roomMembers.loading) {
      members = roomMembers.value
    }
  }

  // Get messages for a particular roomId from props
  if (state.firebase.rooms.messages) {
    const roomMessages = state.firebase.rooms.messages[roomId]
    if (roomMessages && !roomMessages.loading) {
      messages = roomMessages.value
    }
  }


  return {
    teamId: state.firebase.team.metadata.value.id,
    userId: state.firebase.userAuth.id,
    messages: messages,
    members: members,
    roomMetadata: metadata,
    clockOffset: state.firebase.clockOffset,
    userMetadata: state.firebase.user.metadata,
    teamMembers: state.firebase.team.members
  }
}

const getMessageItem = (clockOffset, messageInfo) => {
  return {
    type: 'MESSAGE',
    message: messageInfo,
    dayStr: TimeUtils.getDayStr(clockOffset, messageInfo.timestamp),
    timeStr: TimeUtils.getTimeStr(clockOffset, messageInfo.timestamp, 'strict')
  }
}

export default connect(mapStateToProps)(ChatRoomCurrent)



// WEBPACK FOOTER //
// ./src/chat/ChatRoomCurrent.js